/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowBendDoubleUpLeft(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M85.65723,146.34277a8.00053,8.00053,0,0,1-11.31446,11.31446l-48-48a8.00122,8.00122,0,0,1,0-11.31446l48-48A8.00053,8.00053,0,0,1,85.65723,61.65723L43.31348,104ZM136,96.30469V56a8.00066,8.00066,0,0,0-13.65723-5.65723l-48,48a8.00122,8.00122,0,0,0,0,11.31446l48,48A8.00065,8.00065,0,0,0,136,152V112.36768A88.11673,88.11673,0,0,1,216,200a8,8,0,0,0,16,0A104.13965,104.13965,0,0,0,136,96.30469Z" />
    </Svg>
  );
}

export default ArrowBendDoubleUpLeft;
